import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: {
        ...createTableState(),
        data: JSON.parse(localStorage.getItem('company_modules') || '[]')
    },
    filterData: undefined
})

// getters
const getters = {
    moduleCodes(state) {
        return state.table.data.map(m => m.code)
    },
    moduleDetail: state => moduleID =>
        state.table.data.find(m => moduleID === m.id),
}

// actions
const actions = {
    // get records
    async get({state, commit, rootState}, {filterData} = {}) {
        commit('setLoading', true)

        state.filterData = filterData;

        let params = {};

        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoints['company_module'], {
            params: params
        })

        const {data} = res.data
        commit('updateTableData', data)
        localStorage.setItem('company_modules', JSON.stringify(data))
        this._vm.eventBus.$emit('setModules', data);

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    async setting({state, commit, rootState}, {moduleID} = {}) {
        const res = await this._vm.axios.get(this._vm.endpoints['company_module_setting'], {
            urlVars: { moduleId: moduleID }
        })

        const {data} = res.data

        return data
    },

    async credential({state, commit, rootState}, {moduleID} = {}) {
        const res = await this._vm.axios.get(this._vm.endpoints['company_module_credential'], {
            urlVars: { moduleId: moduleID }
        })

        const {data} = res.data

        return data
    },

    async updateSetting({commit, dispatch, rootState}, {moduleID, settings}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.put(
                this._vm.endpoints['company_module_setting'],
                {settings: settings},
                { urlVars: { moduleId: moduleID } }
            )

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    async updateCredential({commit, dispatch, rootState}, {moduleID, credentials}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.put(
                this._vm.endpoints['company_module_credential'],
                {credentials: credentials},
                { urlVars: { moduleId: moduleID } }
            )

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    // refresh records
    refresh({dispatch}) {
        dispatch('get');
    },

}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
